<template>
  <div>
    <list
      row-key="UserId"
      ref="list"
      unit="套餐缴费流水"
      :expand-all-row="true"
      :page="page"
      :query-params="params"
      :show-checkbox="false"
      :show-query="showQuery"
      :get-data-func="api.list"
      @reset="reset"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <el-form-item label="学校名称">
          <el-select size="mini" v-model="params.SchoolId" clearable @change="query()">
            <el-option v-for="item in schoolList" :key="item.SchoolId" :value="item.SchoolId" :label="item.SchoolName"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="学号">
          <el-input v-model="params.StudentNumber" size="mini" placeholder="请填写学号" clearable/>
        </el-form-item>
        <el-form-item label="卡号">
          <el-input v-model="params.CardNumber" size="mini" placeholder="请填写卡号" clearable/>
        </el-form-item>
        <el-form-item label="姓名">
          <el-input v-model="params.FullName" size="mini" placeholder="请填写姓名" clearable/>
        </el-form-item>
        <el-form-item label="绑定电话">
          <el-input v-model="params.Phone" type="number" size="mini" placeholder="请填写绑定电话" clearable/>
        </el-form-item>
        <!-- <el-form-item label="套餐类型">
          <el-select v-model="params.PackageType" placeholder="请选择套餐类型" clearable>
            <el-option :value="0" label="基础套餐"></el-option>
            <el-option :value="1" label="增值套餐"></el-option>
          </el-select>
        </el-form-item> -->
        <!-- <el-form-item label="缴费日期" prop="StartDate">
          <el-date-picker
            v-model="params.StartDate"
            value-format="yyyy-MM-dd"
            size="mini"
            placeholder="请选择结束时间"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="截止日期" prop="EndDate">
          <el-date-picker
            v-model="params.EndDate"
            value-format="yyyy-MM-dd"
            size="mini"
            placeholder="请选择结束时间"
            clearable
          ></el-date-picker>
        </el-form-item> -->
        <el-form-item label="缴费日期">
          <el-date-picker
            v-model="params.date"
            type="daterange"
            align="right"
            unlink-panels
            @change="setDate"
            range-separator="至"
            value-format="yyyy-MM-dd"
            size="mini"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            style="width:300px;"
            :picker-options="pickerOptions">
          </el-date-picker>
        </el-form-item>
      </template>
      <template slot="table">
        <el-table-column prop="SchoolName" label="学校名称" min-width="120"/>
        <el-table-column prop="StudentNumber" label="学号"/>
        <el-table-column prop="CardNumber" label="卡号"/>
        <el-table-column prop="FullName" label="姓名"/>
        <el-table-column prop="ContactNumber1" label="电话一" min-width="110"/>
        <el-table-column prop="Call2" label="电话二" min-width="110"/>
        <el-table-column prop="ContactNumber3" label="电话三" min-width="110"/>
        <el-table-column prop="PackageType" label="套餐类型">
          <template slot-scope="{row}">
            {{row.PackageType==0?"基础套餐":"增值套餐"}}
          </template>
        </el-table-column>
        <el-table-column prop="Amount" label="缴费金额"/>
        <el-table-column prop="AddTime" label="缴费时间" width="160" />
        <el-table-column label="套餐周期" width="130">
          <template slot-scope="{row}">
            {{ row.StartMonth }} - {{ row.EndMonth }}
          </template>
        </el-table-column>
        <!-- <el-table-column label="收费月份">
          <template slot-scope="{row}">
            {{row.TotalMonth - row.FreeMonth}}
          </template>
        </el-table-column> -->
        <!-- <el-table-column prop="FreeMonth" label="赠送月份">
          <template slot-scope="{row}">
            {{row.PackageType==1?row.FreeMonth:""}}
          </template>
        </el-table-column> -->
        <!-- <el-table-column label="每月赠送套餐外话费" min-width="130">
          <template slot-scope="{row}">
            <span v-if="row.PackageType==1">{{row.GiveCharge}}</span>
          </template>
        </el-table-column> -->
        <el-table-column prop="BaseCharge" label="基础话费"/>
        <el-table-column prop="VaCharge" label="增值费用">
          <template slot-scope="{row}">
            {{row.PackageType==1?row.VaCharge:""}}
          </template>
        </el-table-column>
        <slot name="column"></slot>
      </template>
    </list>
    <!-- <export-dialog ref="exportDialog" /> -->
  </div>
</template>
<script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";
// import exportDialog from "./exportDialog";

export default {
  mixins: [listMixin],
  components: { 
    list,
    // exportDialog
  },
  data() {
    return {
      api: require("@/api/consume/packageStu").default,
      schoolApi: require("@/api/st/school").default,
      params: {
        PackageType: 1,
        SchoolId: null,
        CardNumber: "",
        FullName: "",
        StudentNumber: "",
        StartDate: "",
        EndDate: "",
      },
      date: null,
      pickerOptions: {
        shortcuts: [{
          text: '最近7天',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近30天',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近90天',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      schoolList: [],
    };
  },
  beforeMount() {
    this.schoolApi.list({ Status: 1 }).then(res => {
      if(res.Code == 0) {
        this.schoolList = res.Data;
      }
    })
  },
  methods: {
    reset() {
      this.date = null;
    },
    setDate(date) {
      if(date) {
        this.params.StartDate = date[0];
        this.params.EndDate = date[1];
      } else {
        this.params.StartDate = "";
        this.params.EndDate = "";
      }
      this.query();
    },
    export() {
      this.api.export(
        this.$commonJs.obj.removeNullKey({ ...this.$refs.list.tempQueryParams, ExportType: 1 })
      );
    },
  },
};
</script>